import { useRouterState } from "@tanstack/react-router";
import { useEffect, useRef } from "react";

import { useAuthOperations } from "~/contexts/auth_query";
import { useConfig } from "~/contexts/config";
import { initClarity, isClarityInitialized } from "~/services/analytics";

export function useClarity(): void {
  const config = useConfig();
  const { canExecuteAnyAdminOperation } = useAuthOperations();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const hasAttemptedInit = useRef(false);

  useEffect(() => {
    if (hasAttemptedInit.current || isClarityInitialized()) {
      return;
    }

    const clarityProjectId = config.analytics?.clarityProjectId;
    if (!clarityProjectId) {
      return;
    }

    if (canExecuteAnyAdminOperation()) {
      // Mark as attempted so we don't re-evaluate on every render. Admin users
      // are never tracked, even if their permissions change during the session.
      hasAttemptedInit.current = true;
      return;
    }

    if (!pathname.startsWith("/clients/")) {
      return;
    }

    hasAttemptedInit.current = true;
    initClarity(clarityProjectId);
  }, [
    config.analytics?.clarityProjectId,
    canExecuteAnyAdminOperation,
    pathname,
  ]);
}
